import { NgModule } from '@angular/core';
import { ModalWrapperComponent } from './modalWrapper.component';
import { ModalFooterDirective } from './modalFooter.directive';

@NgModule({
    imports: [ModalWrapperComponent, ModalFooterDirective],
    exports: [ModalWrapperComponent, ModalFooterDirective],
})
export class ModalWrapperModule {}
